import { render } from "./FormStep2.vue?vue&type=template&id=b316befe&scoped=true"
import script from "./FormStep2.vue?vue&type=script&lang=js"
export * from "./FormStep2.vue?vue&type=script&lang=js"

import "./FormStep2.vue?vue&type=style&index=0&id=b316befe&lang=scss"
import "./FormStep2.vue?vue&type=style&index=1&id=b316befe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b316befe"]])

export default __exports__